module.exports = __webpack_public_path__ + "static/media/EVIGARTENICON.721afaea.jpg";